export const extractFilename = (filename = "") => filename.split("_klp_")[0];

export const hasAllKeys = (source: string[], target: string[]): boolean => {
  if (target.length === 0) {
    return false;
  }

  return target.every(key => source.includes(key));
};
